import _ from "lodash";
import { Feature } from "./feature";

const featureValues = Object.values(Feature).sort().reverse();

const featureKeys = Object.keys(Feature);

// const findFeature = (v) => {
//     return featureKeys.find(key => Feature[key] === v);
// }

/* Parses a number or delimited list of feature keys.
   Deliminator can be "|" or "," 
*/
export const parseFeatures = (value: string) => {
    const intValue = parseInt(value);

    if (!isNaN(intValue)) {
        return getFeatures(intValue);
    }

    const features: any = [];

    if (!_.isString(value) || (_.isString(value) && value.length === 0)) {
        return features;
    }

    let delimiter = "|";
    delimiter = value.includes(delimiter) ? delimiter : ",";
    const featureNames = value.split(delimiter);

    for (let i = 0; i < featureNames.length; i++) {
        const featureName = featureNames[i];
        if (featureKeys.includes(featureName)) {
            const key = featureName as keyof typeof Feature;
            features.push(Feature[key]);
        }
    }

    return features;
}

const getFeatures = (value: number) => {
    const features: any = [];

    if (!_.isNumber(value)) {
        return features;
    }

    for (let i = 0; i < featureValues.length; i++) {
        const featureValue = featureValues[i];

        if (value >= featureValue) {
            value -= featureValue;
            //features.push(findFeature(featureValue));
            features.push(featureValue);
            continue;
        }
    }

    return features;
}

export default parseFeatures;
